import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import HomePage    from './pages/HomePage';
import DepotPage   from './pages/DepotPage';
import LoginPage   from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import SuiviPage   from './pages/SuiviPage';
import MesColisPage from './pages/MesColisPage';
import ComptePage from './pages/ComptePage';
import ColisContext from './data/ColisContext';
import RequireAuth from './components/RequireAuth';
import RequireAdmin from './components/RequireAdmin';

export default function App() {
  return (
    <ColisContext>
      <BrowserRouter>
        <Routes>
          <Route path="/"         element={<HomePage />} />
          <Route path="/dashboard" element={<RequireAuth><DashboardPage /></RequireAuth>} />
          <Route path="/login"    element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/depot"    element={<RequireAuth><DepotPage /></RequireAuth>} />
          <Route path="/admin" element={<RequireAdmin><DashboardPage /></RequireAdmin>} />
          <Route path="/mes-colis" element={<RequireAuth><MesColisPage /></RequireAuth>} />
          <Route path="/compte" element={<RequireAuth><ComptePage /></RequireAuth>} />
          <Route path="/suivi"    element={<SuiviPage />} />
          <Route path="*"         element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ColisContext>
  );
}
